import React from "react";
import {Dialog, Slide} from "@mui/material";
import styled from "@emotion/styled";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const SlideDialog = styled((props) => (
    <Dialog
        {...props}
        TransitionComponent={Transition}
    />
))(({theme}) => ({}));

SlideDialog.propTypes = Dialog.propTypes;